import { z } from 'zod';

export const BuyA1XSchema = z.object({
  fromToken: z.object({
    identifier: z.string(),
    decimals: z.number(),
    balance: z.string().optional(),
    ticker: z.string().optional(),
    name: z.string(),
  }).optional(),
  amountDenominated: z.string().optional(),
  slippage: z.number().default(500), // 0.5% default slippage
});

export type BuyA1XSchema = z.infer<typeof BuyA1XSchema>;